import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutProspectActivityList extends Layout {
    layoutheaderProspectActivityList: LayoutHeader;
    sourceProspectActivity: DataSource;
    tableProspectActivities: Table;
}
